{
	"positions": {
		"ticker": "Ticker",
		"option": "Option",
		"marketValue": "Market value",
		"quantity": "Quantity",
		"priceAveragePrice": "Price/avg",
		"profitabilityPerDay": "P&L day $/%",
		"profitability": "P&L $/%",
		"profitabilityInDollar": "P&L $",
		"profitabilityInPercent": "P&L %",
		"actions": "Actions",
		"empty": "No positions",
		"price": "Price",
		"averagePrice": "Average Price",
		"transactionsEmpty": "No transactions",
		"position": "Position",
		"positionSuccessClose": "The closing order has been created",
		"couldn'tClosePosition": "Couldn't close position.",
		"info": "Info",
		"execution": "Execution",
		"close": "Close",
		"sltp": "SL/TP",
		"edit": "Edit",
		"share": "Share",
		"status": {
			"accepted": "Accepted"
		},
		"total": "Total"
	}
}
